import type { SVGProps } from 'react';

const SvgFontDownload = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    {...props}
  >
    <path d="M9.93 13.5h4.14L12 7.98zM22 2H2v20h20zm-6.05 16.5-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13z" />
  </svg>
);
export default SvgFontDownload;
